module.exports = __webpack_public_path__ + "static/media/specialty-self-storage.78c920db.svg";